const HERO_BG = "https://customer-assets.emergentagent.com/job_celebration-hub-359/artifacts/s6171rwc_MINE2.jpeg";
const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Decoração de festa elegante"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto px-6 lg:px-12">
        <p
          className="text-[#E4DCCC] text-sm md:text-base tracking-[0.3em] uppercase mb-6 animate-fade-in-up opacity-0 stagger-1"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          Decoração de Festas em Brasília
        </p>
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight leading-tight mb-6 animate-fade-in-up opacity-0 stagger-2"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Onde os sonhos ganham
          <span className="block text-[#E4DCCC]">forma, cor e emoção</span>
        </h1>
        <p
          className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 font-light animate-fade-in-up opacity-0 stagger-3"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          Somos especialistas em decorações de festas personalizadas e temáticas.
          Celebre o que realmente importa.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up opacity-0 stagger-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-btn"
            className="inline-flex items-center justify-center gap-2 bg-[#E4077B] hover:bg-[#c8066a] text-white px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300 hover:shadow-xl hover:shadow-[#E4077B]/30"
          >
            Falar com Amine Festas
          </a>
          <a
            href="#galeria"
            data-testid="hero-gallery-btn"
            className="inline-flex items-center justify-center gap-2 border border-white/30 text-white hover:bg-white/10 px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300"
          >
            Ver Decorações
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-white/60 rounded-full" />
        </div>
      </div>
    </section>
  );
}
